import { render } from "./ImportacaoAetAgeto.vue?vue&type=template&id=0267e2e9"
import script from "./ImportacaoAetAgeto.vue?vue&type=script&lang=ts"
export * from "./ImportacaoAetAgeto.vue?vue&type=script&lang=ts"
script.render = render

export default script